import script from "./UIGameNotificationItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./UIGameNotificationItem.vue?vue&type=script&lang=ts&setup=true"

import "./UIGameNotificationItem.vue?vue&type=style&index=0&id=0b1a09f2&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src024011243/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b1a09f2"]])

export default __exports__